
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4L10.3594 4L19.8594 20M5 4L14.3594 20H19.8594M5 4L10.5 13.4023V20H5L5 4ZM19.8594 20L14.3594 10.7368L14.3594 4H19.8594L19.8594 20Z","stroke":"#EE7F1A","stroke-width":"2","stroke-linejoin":"round"}})])
          )
        }
      }
    